import React, { useContext, useEffect} from 'react';
import { useNewUser } from '../../../../hooks/useNewUser'
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import tbl from '../../../../assets/Style/Table.module.css'
import { useClient } from '../../../../hooks/useClient';
import { useDealer } from '../../../../hooks/useDealer';
 import AddUserModal from './UserAdd/Add';
import { useUser } from '../../../../hooks/useUser';
  
const NewUserList = () => {
  const { newUserService } = useNewUser(20);
  const { clientService } = useClient(-1);
  const { dealerService } = useDealer(-1);
  const { userService } = useUser(-1);

  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
        newUserService.fetchList()
    }, [])
 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        newUserService.setFilter({
        ...newUserService.filter,
        [name]: value
        });
    };
     
  return <div>

    <div className={ cl.headMain }> 
        <h1>ახალი დარეგისტირებული</h1>   
    </div>

    <div className={tbl.table + ' ' + cl.table}>

        <table>
            <thead>
                <tr>
                <th className={cl.id} >#</th>
                <th className={ cl.pad0 }>
                    <input name="firstname"  placeholder="სახელი გვარი" value={newUserService.filter.firstname} onChange={handleInputChange} /> 
                </th>
                <th className={ cl.pad0 }>
                    <input name="email" placeholder="ელ-ფოსტა" value={newUserService.filter.email}  onChange={handleInputChange} />
                </th>
                <th className={ cl.pad0 }>
                    <input  name="mobile" placeholder="მობილური" value={newUserService.filter.mobile} onChange={handleInputChange} />
                </th>
                <th className={ cl.pad0 }>
                    <input name="personal" placeholder="პურადი ნომერი" value={newUserService.filter.personal}  onChange={handleInputChange} />
                </th>
                <th> </th> 
                </tr>
            </thead>
            <tbody>
                {newUserService.items.map((newUser) =>
                    <tr key={newUser.id} >
                    <td className={cl.id} >{newUser.id} </td>
                    <td>{newUser.firstname}  {newUser.lastname}</td>
                    <td>{newUser.email}</td>
                    <td>{newUser.mobile}</td>
                    <td>{newUser.personal}</td>
                    <td className={ cl.btntbl }>
                        <div className={ cl.btns }>
                            <AddUserModal newUserService={newUserService} userService={userService} defaultClient={newUser}/>
                         </div>
                    </td>
                    </tr>  
                )}
            </tbody>
        </table>

    </div>
 
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination 
        total={newUserService.total} 
        perPage={newUserService.filter.limit} 
        current={newUserService.filter.page} 
        paginate={(page) => {
            newUserService.setFilter({
            ...newUserService.filter,
            page: page,
            });
        }}
        setLimit={(limit) => {
            newUserService.setFilter({
            ...newUserService.filter,
            limit: limit,
            });
        }}
    />
  </div>;
}

export default NewUserList;